import { isDialerHoliday } from "../../domain/time";

/** Error text at >= 4.5:1 on the card background (the destructive token #EF4444 is only 3.8:1). */
export const ERROR_TEXT = "text-sm font-medium text-red-700 dark:text-red-300";

export function formatPhone(e164: string | null): string {
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164 ?? "");
  return m ? `+1 ${m[1]} ${m[2]}-${m[3]}` : (e164 ?? "");
}

/** Dec 25 / Jan 1 in `tz` (the dialer holidays); an unknown zone is never a holiday here (display only). */
export const holidayIn = (at: Date, tz: string): boolean => {
  try {
    return isDialerHoliday(at, tz);
  } catch {
    return false;
  }
};

const intlLocale = (locale: string) => (locale === "en" ? "en-CA" : "fr-CA");

export const dateTimeIn = (iso: string, tz: string, locale = "fr") =>
  new Intl.DateTimeFormat(intlLocale(locale), {
    timeZone: tz,
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(iso));

export const timeIn = (at: Date, tz: string, locale = "fr") =>
  new Intl.DateTimeFormat(intlLocale(locale), {
    timeZone: tz,
    hour: "2-digit",
    minute: "2-digit",
  }).format(at);

/** GAVION requeue fix: "HH:MM" (24 h) of an instant in `tz`, for clockLabel. */
export const hhmmIn = (iso: string, tz: string) =>
  new Intl.DateTimeFormat("en-GB", {
    timeZone: tz,
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(new Date(iso));

/** "10:00" → "10 h" (fr) / "10:00 a.m." style (en); "13:30" → "13 h 30" / "1:30 p.m.". */
export function clockLabel(hhmm: string, locale = "fr"): string {
  const m = /^(\d{2}):(\d{2})$/.exec(hhmm);
  if (!m) return hhmm;
  const h = Number(m[1]);
  const min = m[2];
  if (locale === "en") {
    const h12 = h % 12 === 0 ? 12 : h % 12;
    return `${h12}${min === "00" ? "" : `:${min}`} ${h < 12 ? "a.m." : "p.m."}`;
  }
  return `${h} h${min === "00" ? "" : ` ${min}`}`;
}
